import React from "react";
import { CheckCircle2, Ban } from "lucide-react";

/**
 * Display only: the modules this practice bought SEPARATELY, as the billing summary
 * states them (`billing_breakdown.addons[]`:
 * `{key, name, amount, period, capability, retired}`). The practice keeps them across
 * plan changes.
 *
 * A `retired` line is still billed — its capability is not built (it was withdrawn to
 * "coming soon" after purchase) and an operator removes it from the bill — so it is shown
 * WITHOUT the check a working feature gets, and with the sentence that says what happens
 * to it. Names come from the locale layer; the wire `name` is the Stripe product name
 * ("Add-on: crm"), a matching key rather than copy, so an unknown module falls back to its
 * key.
 */
export default function PaidAddonsCard({ lines, t }) {
  const active = Array.isArray(lines) ? lines.filter((l) => l && l.key) : [];
  if (active.length === 0) return null;
  return (
    <div className="bg-white border border-eh-border-soft rounded-2xl p-6" data-testid="paid-addons">
      <h3 className="font-display text-xl text-eh-ink mb-4">{t("bill.activeAddons")}</h3>
      <div className="grid sm:grid-cols-2 gap-3">
        {active.map((l) => (
          <div key={l.key} data-testid={`paid-addon-${l.key}`} className="bg-eh-cream/30 rounded-xl p-3">
            <div className="flex items-center justify-between gap-3">
              <span className={`font-medium ${l.retired ? "text-eh-muted" : "text-eh-ink"}`}>
                {t(`bill.addonName.${l.key}`, null, l.key)}
              </span>
              {l.retired
                ? <Ban className="w-4 h-4 text-eh-muted" aria-hidden="true" />
                : <CheckCircle2 className="w-4 h-4 text-emerald-500" />}
            </div>
            {l.retired && (
              <p className="mt-1 text-xs text-eh-muted" data-testid={`paid-addon-${l.key}-retired`}>
                {t("bill.addonRetired")}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
